<div class="container-fluid">
    <div class="row pt-4">
      <div class="col-md-12 text-center mb-2">
        <small> © 2024 made with <i class="fa fa-heart text-danger" aria-hidden="true"></i> by <span
            class="text-secondary font-weight-bold">APP SOLUCIONES
            </span></small>
      </div>
    </div>
  </div>